/* Progressive enhancement. Shopify's native forms remain functional without JS. */
(() => {
  'use strict';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (root = document) => {
    root.querySelectorAll('.d-menu-toggle:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      const menu = document.getElementById(button.getAttribute('aria-controls'));
      if (!menu) return;
      const close = (restoreFocus = false) => {
        button.setAttribute('aria-expanded', 'false'); menu.hidden = true;
        if (restoreFocus) button.focus();
      };
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open)); menu.hidden = !open;
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close()));
      const header = button.closest('.d-header');
      header.addEventListener('keydown', event => { if (event.key === 'Escape') close(true); });
      header.addEventListener('focusout', event => { if (!header.contains(event.relatedTarget)) close(); });
    });
    root.querySelectorAll('.d-product-form:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const quantity=form.querySelector('[name="quantity"]');
      const select=form.querySelector('[data-variant-select]');
      const add=form.querySelector('[data-add]');
      const label=form.querySelector('[data-add-label]');
      const status=form.querySelector('.d-cart-status');
      if(!add||!label)return;
      const initialAvailable=!add.disabled;
      let pending=false,submittedVariant='';
      const available=()=>select?select.selectedOptions[0]?.dataset.available==='true':initialAvailable;
      const buttons=Array.from(form.querySelectorAll('[data-quantity]'));
      const updateQuantity=()=>{
        if(!quantity)return;
        const value=Number(quantity.value),min=Number(quantity.min)||1,max=quantity.max?Number(quantity.max):Infinity;
        buttons.forEach(button=>{button.disabled=pending||(quantity.value!==''&&(Number(button.dataset.quantity)<0?value<=min:value>=max));});
      };
      const reset=()=>{pending=false;delete form.dataset.submitting;form.removeAttribute('aria-busy');add.removeAttribute('aria-busy');add.disabled=!available();label.textContent=available()?'PREORDINA DYLUMA':'Esaurito';if(quantity)quantity.readOnly=false;if(status)status.textContent='';updateQuantity();};
      buttons.forEach(button=>button.addEventListener('click',()=>{
        if(!quantity||pending)return;
        const direction=Number(button.dataset.quantity);
        if(!quantity.value||!Number.isFinite(Number(quantity.value)))quantity.value=quantity.min||'1';
        try{if(direction>0)quantity.stepUp();else quantity.stepDown();}catch{quantity.value=quantity.min||'1';}
        quantity.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      quantity?.addEventListener('input',updateQuantity);
      quantity?.addEventListener('change',updateQuantity);
      select?.addEventListener('change',()=>{
        if(pending){select.value=submittedVariant;return;}
        const option=select.selectedOptions[0];if(!option)return;
        const price=form.querySelector('[data-price]'),compare=form.querySelector('[data-compare-price]');
        if(price)price.textContent=option.dataset.price||'';
        if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
        add.disabled=!available();label.textContent=available()?'PREORDINA DYLUMA':'Esaurito';
        if(quantity){quantity.min=option.dataset.min||'1';quantity.step=option.dataset.step||'1';if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=quantity.min;}
        if(status)status.textContent=available()?'':'Questa variante è esaurita.';
        updateQuantity();
      });
      form.addEventListener('submit',event=>{
        if(pending||!available()){event.preventDefault();return;}
        // Leave Shopify's native POST, variant ID and quantity in charge.
        if(!form.checkValidity()){event.preventDefault();form.reportValidity();return;}
        pending=true;submittedVariant=select?.value||'';form.dataset.submitting='true';form.setAttribute('aria-busy','true');
        add.disabled=true;add.setAttribute('aria-busy','true');label.textContent='UN ISTANTE';if(quantity)quantity.readOnly=true;
        if(status)status.textContent='Aggiunta al carrello…';updateQuantity();
      });
      window.addEventListener('pageshow',reset);
      updateQuantity();
    });
    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('is-pending'); observer.unobserve(entry.target); }
      }), { threshold: 0.12 });
      root.querySelectorAll('.d-reveal:not([data-ready])').forEach(item => {
        item.dataset.ready = 'true';
        if (item.getBoundingClientRect().top > window.innerHeight) { item.classList.add('is-pending'); observer.observe(item); }
      });
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) { root.querySelectorAll('.is-pending').forEach(item => item.classList.remove('is-pending')); observer.disconnect(); }
      }, { once: true });
    }
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.is-pending').forEach(item => item.classList.remove('is-pending')));
})();
